import { lazy } from 'react';
import { useModal } from 'src/components/modal';
import { VoiceChannelInvite } from 'src/provider/VoiceChannel';

const Component = lazy(() =>
  import('./VoiceChannelCallingDialog').then((module) => ({
    default: module.VoiceChannelCallingDialog,
  })),
);

export const useVoiceChannelInvitedModal = () => {
  const { showModal, hideModal } = useModal(Component);

  return {
    openVoiceChannelCallingDialog(data: VoiceChannelInvite) {
      showModal(data);
    },
    closeVoiceChannelCallingDialog() {
      hideModal();
    },
  };
};
